// extracted by mini-css-extract-plugin
module.exports = {"root":"InputSecondary_root__1ZR4D","error":"InputSecondary_error__3kfxw","disabled":"InputSecondary_disabled__3nNLc"};